<template>
  <div class="body">
    <fuzhen_tabs :paths="docid" :name="docname" />
    <div class="doctor-info">
      <div class="header">
        <div class="doc-head">
          <img :src="doctorinfo.avatar?doctorinfo.avatar:'../../../static/logo.png'" alt />
        </div>
        <div class="doc-content display_flex_start flex_wrap">
          <div class="doc-name">{{doctorinfo.zname}}
            <div class="doc-save" @click.stop="handleToFav(doctorinfo.id,doctorinfo.type)" v-if="doctorinfo.type && doctorinfo.type != 3"><img :src="doctorinfo.type == 1?img_src:img_src1" alt="" /></div>
            <div class="doc-save" v-if="doctorinfo.type == 3">问诊过</div>
          </div>
          <div class="doc-pos display_flex_start font-65">
            {{doctorinfo.position}}
            <!-- <span
              class="exper-num"
              v-if="doctorinfo.is_num>0"
            >问诊{{doctorinfo.is_num}}次</span> -->
          </div>
          <p class="doc-hosp">{{doctorinfo.hospname}}</p>
        </div>
      </div>
      <div class="info-center">
        <div class="doc-label-list display_flex_start" v-if="doctorinfo.label">
          <div
            class="doc-label display_flex_start"
            v-for="(label_item,label_index) in doctorinfo.label_list"
            v-show="label_index<3"
            :key="label_index"
          >{{label_item}}</div>
        </div>
        <div class="follow">
          <i class="icon icon-follow-no"></i>
        </div>
      </div>
      <div class="goodbe overflow">
        {{doctorinfo.goodable}}
        <span @click="handleMore" class="more">更多信息</span>
      </div>
    </div>
    <div class="service display_flex_between flex_wrap">
      <div class="service-title display_flex_start font-85">服务</div>

      <div class="service-item" :class="{'service-item-no':doctorinfo.is_graphic == 1}" @click="routePush(doctorinfo.is_graphic,'/select_patient?doctorid='+docid+'&type=1')">
        <div class="icon icon-service icon-tuwen" :class="{'is_open':doctorinfo.is_graphic == 0,'is_close':doctorinfo.is_graphic == 1}"></div>
        <div class="service-txt">图文问诊</div>
        <span class="rmb" v-if="doctorinfo.is_graphic == 0">￥{{doctorinfo.graphic_money}}</span>
        <span class="rmb close" v-else>暂未开通</span>
      </div>
      <div class="service-item" :class="{'service-item-no':doctorinfo.is_phone == 1}" @click="routePush(doctorinfo.is_phone,'/select_patient?doctorid='+docid+'&type=2')">
        <div class="icon icon-service icon-phone" :class="{'is_open':doctorinfo.is_phone == 0,'is_close':doctorinfo.is_phone == 1}"></div>
        <div class="service-txt">电话问诊</div>
        <span class="rmb" v-if="doctorinfo.is_phone == 0">￥{{doctorinfo.phone_money}}</span>
        <span class="rmb close" v-else>暂未开通</span>
      </div>
      <div class="service-item service-item-no" style="margin-top:1rem;">
        <!-- <div class="icon icon-service icon-guahao" :class="{'is_open':doctorinfo.ismake == 1,'is_close':doctorinfo.is_phone == 0}"></div> -->
        <div class="icon icon-service icon-guahao is_close" ></div>
        <div class="service-txt">预约挂号</div>
        <!-- <span class="rmb" v-if="doctorinfo.ismake == 1">￥{{doctorinfo.phone_money}}</span> -->
        <span class="rmb close">暂未开通</span>
      </div>
      <div class="service-item service-item-no" style="margin-top:1rem;">
        <div class="icon icon-service icon-video" :class="{'is_open':doctorinfo.is_video == 0,'is_close':doctorinfo.is_video == 1}"></div>
        <div class="service-txt">视频问诊</div>
        <span class="rmb" v-if="doctorinfo.is_video == 0">￥{{doctorinfo.video_money}}</span>
        <span class="rmb close" v-else>暂未开通</span>
      </div>
    </div>
  </div>
</template>

<script>
import fuzhen_tabs from "../../components/fuzhen_tabs/fuzhen_tabs";
import http from "../../request/http";
export default {
  name: "doctor_content",

  data() {
    return {
      doctorinfo: [],
      docid: "",
      img_src:'../../../static/icons/guanzhu_false@3x.png',
      img_src1:'../../../static/icons/guanzhu_true@3x.png',
      docname:''
    };
  },
  components: {
    fuzhen_tabs,
  },
  mounted() {
    let docid = this.$route.query.doctorid;
    this.docid = docid;
    this.docInfo(docid);
  },
  methods: {
    handleToFav(id,type){
      let data = {
        docid:id,
        fan_tag:+type
      }
      http.post('/api/wap/doctor/fan',data).then(res => {
        if(res.errno == 0){
          this.doctorinfo.type = type == 1?2:1;
        }
      })
    },
    docInfo(id) {
      http
        .post("/api/wap/doctor/info", { doctorId: id })
        .then((res) => {
          if (res.data && res.data.length) {
            let data = res.data[0];
            // data.is_num = 0;
            this.docname = data.zname;
            data.graphic_money =data.graphic_money?(data.graphic_money/100).toFixed(2):0;
            data.phone_money =data.phone_money?(data.phone_money/100).toFixed(2):0;
            data.label_list = [];
            if (data.label) {
              data.label_list = data.label.split(",");
            }
            // data.is_num = +data.is_graphic + +data.is_phone + +data.is_video;
            this.doctorinfo = data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    routePush(type,path) {
      if(type == 0){
        this.$router.push(path);
      }
    },
    handleMore() {
      this.$router.push('/doctor_detail?doctorid='+this.docid)
    },
  },
};
</script>

<style scoped>
.body {
  padding: 2.4rem 0 1rem 0;
  background: #fff;
}
.doctor-info {
  width: 100%;
  height: auto;
  background: rgba(24, 144, 255, 0.01);
  padding: 1.3rem 0.8rem 0.8rem 1rem;
  position: relative;
}
.doc-save{
  float:right;
  min-width:1rem;
  height: 0.75rem;
  margin-top:0.2rem;
  font-size: 0.6rem;
  color:rgba(24,144,255,1);
  text-align: right;
}
.doc-save img{
  width: 0.75rem;
  height: 100%;
  vertical-align: top;
}
.header {
  width: 100%;
  margin-bottom: 0.7rem;
  display: flex;
  justify-content: start;
  align-items: start;
}
.doc-content {
  width: calc(100% - 4.4rem);
}
.doc-content .doc-name {
  width: 100%;
  font-size: 1.2rem;
  height: 1.3rem;
  line-height: 1.3rem;
  color: rgba(38, 38, 38, 1);
  margin-bottom: 0.45rem;
}
.doc-content .doc-pos {
  width: 100%;
  height: 1.2rem;
  font-size: 0.7rem;
}
.doc-content .doc-hosp {
  width: 100%;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.5);
}
.doc-head {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 0.9rem;
}
.doc-head img {
  width: 100%;
  height: 100%;
}
.info-center {
  margin-bottom: 0.5rem;
  font-size: 0.6rem;
  display: flex;
  justify-content: space-between;
}
.doc-tabs span {
  display: inline-block;
  padding: 0 0.5rem;
  background: #fa8c16;
  color: #fff;
}
.goodbe {
  line-height: 1.1rem;
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.7rem;
  height: 2.2rem;
  position: relative;
}
.overflow {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.goodbe .more {
  position: absolute;
  bottom: 0rem;
  right: 0.1rem;
  color: #1890ff;
  background: #fff;
}
.more::after {
  display: inline-block;
  content: "";
  width: 0.4rem;
  height: 0.4rem;
  border-top: 0.05rem solid rgba(24, 144, 255, 1);
  border-right: 0.05rem solid rgba(24, 144, 255, 1);
  transform: rotate(45deg);
  margin-left: 0.2rem;
}
.more::before{
  display: inline-block;
  content:'...';
  width: 1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  color:rgba(0, 0, 0, 0.5);
}
.service {
  width: 100%;
  padding: 0.8rem 1.5rem;
  background: #fff;
}
.service-title {
  width: 100%;
  height: 1.25rem;
  line-height: 1.25rem;
  font-size: 0.9rem;
  margin-bottom: 0.9rem;
}
.service-title::before {
  display: block;
  content: "";
  width: 0.15rem;
  height: 0.8rem;
  border-radius: 0.05rem;
  background-color: rgba(24, 144, 255, 1);
  margin-right: 0.25rem;
}
.service-item {
  width: calc(50% - 0.5rem);
  height: 7.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: flex-start;
  flex-wrap: wrap;
  padding-top: 1.3rem;
  box-sizing: border-box;
  border-radius: 0.25rem;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 0.2rem 0.2rem 0.1rem rgba(0, 0, 0, 0.02);
  border: 0.025rem solid rgba(0, 0, 0, 0.1);
}
.service-item .service-txt {
  width: 100%;
  height: 1.1rem;
  line-height: 1.1rem;
  color: rgba(38, 38, 38, 1);
  margin: 0.35rem 0 0.25rem 0;
  font-size: 0.8rem;
  text-align: center;
}
.icon-service {
  width: 2rem;
  height: 2rem;
  background-size: 100% 100%;
}
.icon-tuwen.is_open {
  background-image: url("../../../static/icons/picture@3x.png");
}
.icon-tuwen.is_close {
  background-image: url("../../../static/icons/picture_false@3x.png");
}
.icon-phone.is_open {
  background-image: url("../../../static/icons/call1@3x.png");
}
.icon-phone.is_close {
  background-image: url("../../../static/icons/call_false@3x.png");
}
.icon-guahao.is_open {
  background-image: url("../../../static/icons/yuyue_true@3x.png");
}
.icon-guahao.is_close {
  background-image: url("../../../static/icons/yuyue@3x.png");
}
.icon-video.is_open {
  background-image: url("../../../static/icons/shipin_true@3x.png");
}
.icon-video.is_close {
  background-image: url("../../../static/icons/shipin@3x.png");
}
.display_flex_start,
.display_flex_between,.flex_start_s {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.display_flex_between {
  justify-content: space-between;
  align-content: flex-start;
}
.flex_start_s{
  align-items: flex-start;
}
.flex_wrap {
  flex-wrap: wrap;
}
.exper-num {
  height: 0.9rem;
  line-height: 0.8rem;
  font-size: 0.6rem;
  padding: 0.05rem 0.2rem;
  color: rgba(24, 144, 255, 1);
  border-radius: 0.15rem;
  margin-left: 0.25rem;
  background-color: rgba(230, 247, 255, 1);
}
.doc-label {
  padding: 0 0.35rem;
  height: 1rem;
  box-sizing: border-box;
  border: 0.05rem solid rgba(250, 140, 22, 0.5);
  border-radius: 0.15rem;
  font-size: 0.6rem;
  color: rgba(250, 140, 22, 1);
}
.doc-label + .doc-label {
  margin-left: 0.4rem;
}
.rmb {
  width: 100%;
  height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.8rem;
  color: rgba(255, 28, 41, 1);
  text-align: center;
  display: block;
}
.close {
  height: 1rem;
  line-height: 1rem;
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.25);
}
.service-item-no{
  background-color: rgba(250, 250, 250, 1);
  border:none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/doctor/doctor_content.vue